<template>
  <div class="page-container">

    <el-row :gutter="10">
      <el-col :span="12">
        <div class="data-filter title-field">
          <span>회사: </span>
          <span v-if="company.company_name">{{company.company_name}}</span>
          <span class="dimmed-text" v-else>( 개인사용자 )</span>
          &nbsp;&nbsp;&nbsp;
          <span>관리자: </span>
          <span v-if="admin">{{admin.mgrid}} / {{admin.name}}</span>
          <span class="dimmed-text" v-else>( 관리자 없음 )</span>
          <!-- <template v-if="admin">
            <el-button size="mini" type="danger" @click="$service.forceLogin(admin.token)">강제 로그인</el-button>
          </template> -->
        </div>
        <el-tabs type="border-card">

          <!-- 고객정보 패널 -->
          <el-tab-pane label="고객정보">
            <el-table :data="managers" :show-header="false" size="mini">
              <el-table-column width="40">
                <template slot-scope="scope">
                  <i v-if="scope.row.user_type === 2" class="el-icon-star-on user-type-icon user-type-admin"></i>
                  <i v-else-if="scope.row.user_type === 1" class="el-icon-user-solid user-type-icon user-type-user"></i>
                </template>
              </el-table-column>
              <el-table-column prop="mgrid"></el-table-column>
              <el-table-column prop="name" width="100"></el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  {{scope.row.email}}<br v-if="scope.row.email && scope.row.phone">{{scope.row.phone}}
                </template>
              </el-table-column>
              <el-table-column width="90px">
                <template slot-scope="scope">
                  <el-button size="mini" circle 
                    type="success" 
                    icon="el-icon-edit" 
                    @click="$router.push({name: 'management-user', params: {user_pk: scope.row.pk}})">
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

          <!-- 라이센스 패널 -->
          <el-tab-pane label="라이센스 및 결제이력" v-loading="loading">
            <div v-if="loaded" class="data-table">
              <el-alert :type="license.total.expireWarnings.length ? 'danger' : 'success'" :closable="false">
                총 {{license.total.count}} 라이센스 /
                {{license.total.primaryProdType}} / {{license.total.vol}} 대 / {{license.total.lastestExpireDate | moment('YYYY-MM-DD')}} 까지
              </el-alert>

              <el-table :data="license.list" :show-header="false" :row-class-name="licenseStatus">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table v-if="props.row.linked" :data="props.row.linked" :show-header="false" size="mini">
                      <el-table-column label="날짜" width="180">
                        <template slot-scope="scope">
                          결제일: {{ scope.row.create_time | moment('YYYY-MM-DD HH:mm:ss') }}
                          <br>
                          시작일: {{ scope.row.start_date | moment('YYYY-MM-DD HH:mm:ss') }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="type" label="라이센스 타입" width="80"></el-table-column>
                      <el-table-column label="결제수단">
                        <template slot-scope="scope">{{$service.getPaymentMethod('value', scope.row.payment_method).name}}</template>
                      </el-table-column>
                      <el-table-column label="금액">
                        <template slot-scope="scope">{{scope.row.price | currency('₩', 0)}}</template>
                      </el-table-column>
                      <el-table-column>
                        <template slot-scope="scope">
                          <el-row style="display: flex; justify-content: flex-end;">
                            <el-button size="mini" type="info" @click="deleteLicense(scope.row)" style="background: red; border-color: red;">삭제</el-button>
                          </el-row>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column label="날짜" width="180">
                  <template slot-scope="scope">{{ scope.row.expire_date | moment('YYYY-MM-DD') }} 까지</template>
                </el-table-column>
                <el-table-column label="장치 수">
                  <template slot-scope="scope">{{scope.row.device_vol}} 대 이용</template>
                </el-table-column>
                <el-table-column label="갱신" width="225">
                  <div style="text-align:right" slot-scope="scope">
                    <el-button size="mini" type="info" @click="openEditLicenseDialog(scope.row)">수정</el-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div v-else style="height: 200px"></div>
          </el-tab-pane>

          <!-- 업체관리 -->
          <el-tab-pane label="업체관리">
            <div class="company-setting" v-if="loaded">
              <el-form ref="company_form" :model="company" label-width="240px" size="mini">
                <el-form-item label="회사이름">
                  <el-input v-model="company.company_name" />
                </el-form-item>
                <el-form-item label="사용자 삭제 시">
                  <el-select v-model="company.flag_user_not_delete">
                    <el-option label="비활성화" :value="true" />
                    <el-option label="삭제" :value="false" />
                  </el-select>
                </el-form-item>
                <el-form-item label="관리자 지정 라이센스 이름">
                  <el-input v-model="company.custom_payment.name" />
                </el-form-item>
                <el-form-item label="관리자 지정 라이센스 가격">
                  <el-input v-model="company.custom_payment.price" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="updateCompanySetting()">적용</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="12">
        <div class="data-filter">
          <el-button size="mini" type="primary" @click="dialog_memo = true">메모 추가</el-button>
        </div>
        <el-card class="box-card" v-for="memo in memos" :key="memo.pk">
          <div class="card-header">
            <span>
              {{memo.type}} - 
              {{memo.create_time | moment('YYYY-MM-DD HH:mm:ss')}}
            </span>
            <div class="author">
              {{memo.manager}} &nbsp;
              <i class="el-icon-delete delete-memo-btn" @click="deleteMemo(memo)"></i>
            </div>
          </div>
          <div class="card-edit" v-if="memo.__edit">
            <div class="card-edit-func">
              <el-button size="mini" type="success" @click="saveEditMemo(memo)">저장</el-button>
              <el-button size="mini" type="" @click="closeEditMemo(memo)">닫기</el-button>
            </div>
            <el-input
              type="textarea"
              class="card-edit-form"
              autosize
              placeholder="메모를 입력해주세요"
              v-model="memo.__temp_memo">
            </el-input>
          </div>
          <div class="card-body" v-else @click="editMemo(memo)">{{memo.memo}}</div>
        </el-card>
        <el-card class="box-card" v-if="!memos.length">
          <div class="">메모가 없습니다</div>
        </el-card>
      </el-col>
    </el-row>

    <dialog-memo v-model="dialog_memo" @close="dialogMemoHandler" />
    <dialog-license v-model="dialog_license" :license="dialog_license_param" @close="dialogLicenseHandler" />
    <dialog-edit-license v-model="dialog_edit_license" :license="dialog_edit_license_param" @close="dialogEditLicenseHandler" />
    <dialog-delete-license v-model="dialog_delete_license" :license="dialog_delete_license_param" @close="dialogDeleteLicenseHandler" />
  </div>
</template>

<script>
import _ from 'lodash'
import DialogMemo from '@/components/Dialog-memo'
import DialogLicense from '@/components/Dialog-license'
import DialogEditLicense from '@/components/Dialog-editLicense'
import DialogDeleteLicense from "@/components/Dialog-deletelicense.vue";
export default {
  props: ['company_pk', 'back'],
  components: {DialogDeleteLicense, DialogMemo, DialogLicense, DialogEditLicense},
  beforeRouteLeave (to, from, next) {
    if (this.back && this.back.name === to.name) {
      to.params.restore = this.back
    }
    next()
  },
  methods: {
    async getCompany () {
      this.loading = true
      let {data} = await this.$http.get(`company/${this.company_pk}`)
      
      if (data.company.custom_payment && /|/.test(data.company.custom_payment)) {
        let customPay = data.company.custom_payment.split('|')
        data.company.custom_payment = {
          name: customPay[0],
          price: parseInt(customPay[1], 10)
        }
      }
      else {
        data.company.custom_payment = {
          name: '',
          price: null
        }
      }

      this.company = data.company
      this.managers = data.managers
      this.admin = _.find(data.managers, {user_type: 2})
      this.payments = data.payments
      this.memos = data.memos.map(v => {
        v.__edit = false
        v.__temp_memo = v.memo
        return v
      })
      this.license = this.calcLicense(data.payments)

      this.loading = false
      this.loaded = true
      return data
    },
    async updateCompanySetting () {
      let params = {
        flag_user_not_delete: this.company.flag_user_not_delete,
        company_name: this.company.company_name
      }

      if (this.company.custom_payment.name && this.company.custom_payment.price) {
        if (!parseInt(this.company.custom_payment.price)) {
          return this.$message.error('가격에는 숫자만 입력할 수 있습니다');
        }
        if (!/^[a-zA-Z가-힣0-9]+$/.test(this.company.custom_payment.name)) {
          return this.$message.error('이름에는 영문, 숫자, 한글만 입력할 수 있습니다');
        }
        params.custom_payment = this.company.custom_payment.name + '|' + this.company.custom_payment.price
      }
      else {
        params.custom_payment = null
      }
      let {status} = await this.$http.put(`company_update/${this.company_pk}`, params)
      if (status === 200) {
        this.$message({
          message: '업체 설정이 수정되었습니다',
          type: 'success'
        });


      }
    },
    async getMemo () {
      let query = {
        filters: [{name: 'company_fk', op: 'eq', val: parseInt(this.company_pk, 10)}]
      }
      let params = { q: JSON.stringify(query) }
      let {data} = await this.$http.get('memo', {params})
      this.memos = data.objects.map(v => {
        v.__edit = false
        v.__temp_memo = v.memo
        return v
      })
    },
    async dialogMemoHandler (memo) {
      this.dialog_memo = false
      if (memo) {
        this.$service.localdb.setItem('admin_name', memo.manager)
        memo.company_fk = parseInt(this.company_pk, 10)
        let {status} = await this.$http.post('memo', memo)
        if (status === 201) {
          this.getMemo()
          this.$message({
            message: '메모가 추가되었습니다',
            type: 'success'
          });
        }
      }
    },
    async deleteMemo (memo) {
      let {status} = await this.$http.delete(`memo/${memo.pk}`)
      if (status === 204) {
        this.getMemo()
        this.$message({
          message: '메모가 삭제되었습니다',
          type: 'success'
        });
      }
    },
    userClickHandler (row, col) {
      console.log(col)
      this.$router.push({name: 'management-user', params: {user_pk: row.pk}})
    },
    async saveEditMemo (memo) {
      let params = {
        memo: memo.__temp_memo
      }
      let {status} = await this.$http.put(`memo/${memo.pk}`, params)
      if (status === 200) {
        this.$message({
          message: '메모가 수정되었습니다',
          type: 'success'
        });
        memo.memo = memo.__temp_memo
      }
      else {
        memo.__temp_memo = memo.memo
      }
      memo.__edit = false
    },
    openLicenseDialog (license) {
      this.dialog_license_param = license || null
      this.dialog_license = true
    },
    openEditLicenseDialog (license) {
      this.dialog_edit_license_param = license || null
      this.dialog_edit_license = true
    },
    deleteLicense (license) {
      this.dialog_delete_license_param = license || null
      this.dialog_delete_license = true
    },
    async dialogEditLicenseHandler (update) {
      this.dialog_edit_license = false
      this.dialog_edit_license_param = null

      if (!update)  return;
      
      if (update.start_date)
        update.start_date = this.$service.moment(update.start_date).startOf('day').format('YYYY-MM-DD HH:mm:ss')

      if (update.expire_date)
        update.expire_date = this.$service.moment(update.expire_date).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      
      let {status} = await this.$http.put(`license/${update.pk}`, update)
      if (status) {
        this.getCompany()
        this.$message.success('라이센스가 변경되었습니다')
      }
      else this.$message.error('라이센스가 변경에 실패하였습니다')
      return;
    },
    async dialogLicenseHandler (license) {
      this.dialog_license = false
      this.dialog_license_param = null

      if (!license) return;

      let start = this.$service.moment(license.start_date).startOf('day')
      let end = this.$service.moment(license.expire_date).endOf('day')
      
      license.period = end.diff(start, 'month')
      license.start_date = start.format('YYYY-MM-DD HH:mm:ss')
      license.expire_date = end.format('YYYY-MM-DD HH:mm:ss')
      
      if (!license.company_fk) license.company_fk = this.company_pk

      let {status} = await this.$http.post('license', license)
      if (status) {
        this.getCompany()
        this.$message.success('라이센스가 변경되었습니다')
      }
      else this.$message.error('라이센스가 변경에 실패하였습니다')
    },
    async dialogDeleteLicenseHandler (license) {
      this.dialog_delete_license = false
      this.dialog_delete_license_param = null

      if (!license) return;

      let {status} = await this.$http.delete(`license/${license.pk}`)

      if (status) {
        this.getCompany()
        this.$message.success('라이센스가 삭제되었습니다')
      }
      else this.$message.error('라이센스가 변경에 실패하였습니다')
    },
    closeEditMemo (memo) {
      memo.__temp_memo = memo.memo
      memo.__edit = false
    },
    editMemo (memo) {
      memo.__temp_memo = memo.memo
      memo.__edit = true
    },
    licenseStatus ({row}) {
      if (row.isExpired) return 'license-expired'
      if (row.expireWarning) return 'license-warning'
      return ''
    },
    calcLicense (payment) {
      if (!payment || !payment.length) return null
      var today = new Date().getTime()
      var license = []
      var expireWarnings = []
      license = _.clone(payment.filter(v => !v.license_ref))
      
      var lastest, lastestString, managerLimit
      for (var i = 0; i < license.length; i++) {
        var pk = license[i].pk
        var expire = new Date(license[i].expire_date).getTime()
        var type, payDevVol
        var linked = payment.filter(v => v.license_ref === pk)
        if (linked.length) {
          for (var n = 0; n < linked.length; n++) {
            type = linked[n].type
            payDevVol = linked[n].device_vol
            var tmp = new Date(linked[n].expire_date).getTime()
            if (expire < tmp) {
              license[i].expire_date = linked[n].expire_date
              expire = tmp
            }
          }
          if (license[i].type === 'Free') {
            license[i].type = type
            license[i].device_vol = payDevVol
          }
        }
        linked.unshift(license[i])
        license[i].linked = linked

        if (!lastest || lastest < expire) {
          lastest = expire
          lastestString = license[i].expire_date
        }
        license[i].expireTimeStamp = expire
        license[i].isExpired = today > expire
        license[i].expireWarning = today > expire - 604800000
        if (license[i].expireWarning && !license[i].isExpired) expireWarnings.push(license[i])
      }
      managerLimit = license[license.length - 1].manager_limit
      license.sort((a, b) => b.expireTimeStamp - a.expireTimeStamp)
      return {
        total: {
          count: license.length,
          primaryProdType: license[0].type,
          lastestExpireDate: lastest,
          expireWarnings: expireWarnings,
          lastestExpireDateString: lastestString,
          managerLimit: managerLimit,
          vol: license
            .filter(v => !v.isExpired)
            .reduce((sum, item) => sum + item.device_vol, 0)
        },
        list: license
      }
    }
  },
  mounted () {
    this.getCompany()
      .then(response => {
        let admin = _.find(response.managers, {user_type: 2})
        if (!admin) admin = { mgrid: '--' }
        this.$service.addHistory({
          pk: response.company.pk,
          name: response.company.company_name || admin.mgrid,
          favorate: false
        })
      })
  },
  data () {
    return {
      loading: false,
      loaded: false,
      company: {},
      managers: [],
      admin: null,
      payments: [],
      license: {},
      memos: [],
      dialog_memo: false,
      dialog_license: false,
      dialog_license_param: null,
      dialog_edit_license: false,
      dialog_edit_license_param: null,
      dialog_delete_license: false,
      dialog_delete_license_param: null,
    }
  }
}
</script>

<style lang="scss" scoped>
.title-field {
  margin-bottom: 10px;
  height: 28px;
  color: #888;
  font-size: 15px;
  line-height: 28px;
  text-indent: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/deep/ .el-table {
  .license-expired { background-color: #ffe7e7; color: #c70000; }
  .license-warning { background-color: #fbf1d8; color: orange; }
}
.add-license-btn {
  width: 100%;
  margin: 10px 0;
}
.box-card {
  margin-top: 10px;
}
.card-header {
  font-size: 12px;
  color: #bfbfbf;

  .author {
    float: right;
  }
}
.card-body {
  white-space: pre-wrap;
  font-size: 13px;
  color: #828282;
  line-height: 21px;
  padding: 10px 5px;
  cursor: pointer;
}
// .card-edit {}
.card-edit-func {
  padding: 10px 0;
}
.card-edit-form /deep/ textarea {
  font-family: 'Malgun Gothic', sans-serif;
}
.user-type-icon {
  vertical-align: middle;
  font-size: 18px;
}
.user-type-admin { color: #ffb300; }
.user-type-user { color: #c7c7c7; }

.delete-memo-btn {
  cursor: pointer;
  &:hover { color:red; }
}

/deep/ .el-table__expanded-cell[class*=cell] {
  padding: 0 10px;
}

</style>
